$(document).ready(function () {
    $.GNDValidator.addRule("isEmail", /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
        {
            en: {
                'error': 'Email is invalid',
                'warn': 'Email should be valid'
            },
            vi: {
                'error': 'Email không đúng định dạng',
                'warn': 'Email should be valid'
            },
        });

    $.GNDValidator.addRule("uniqueEmail", {
        type: "remote",
        remote: {

            url: ajaxSetup.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                'action': 'check_email_try_sms',
                email: ''
            },


            dataPassElementValue: "email",
            checkSuccess: function (res) {
                console.log(res);
                if (res.exist) return false;
                else if (res.exist == false) return true;

                return false;
            }
        }
    }, {
        en: {
            'error': 'Email is existed',
        },
        vi: {
            'error': 'Email đã tồn tại',
        },
    });

    jQuery('#regserviceform').GNDFormValidate({
        'errorOutputMode': 'single',
        'messageLocale': 'vi',
        'messageSingleTemplate': '{message}',

        successCallBack: function (e) {

            e.preventDefault();

            var $form = jQuery('#regserviceform');
            var $formLoader = $form.find('.loader');
            var $formSuccess = $form.find('.global-message');
            var canCheck = true;
            var dataForm = {};

            $formSuccess.html('');

            $form.find('.validate').each(function () {
                if ($(this).hasClass('error'))
                    canCheck = false;

            });

            canCheck = true;

            if (canCheck) {
                jQuery.each($form.serializeArray(), function (i, obj) {
                    dataForm[obj.name] = obj.value
                });


                jQuery.ajax({
                    timeout: 30000,
                    url: ajaxSetup.ajaxurl,
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        'action': 'reg_try_sms',
                        'form': dataForm
                    },
                    'beforeSend': function () {
                        $formLoader.removeClass('hidden');
                        $formSuccess.html('');
                        $formSuccess.addClass('hidden');
                    },
                    'complete': function () {
                        $formLoader.addClass('hidden');
                    },
                    'success': function (res, status, jo) {

                        console.log(res);

                        if (res.existEmail) {
                            $formSuccess.removeClass('hidden').addClass('error_message').removeClass('success_message').html('Email của quý khách đã đăng ký trước đó');
                        }

                        if (res.result) {
                            if (res.result == 0) {
                                $formSuccess.removeClass('hidden').removeClass('error_message').addClass('success_message').html(res.message);
                                $form[0].reset();
                                $form.find('.validate').removeClass('valid');
                                window.open('http://mobile.aztech.com.vn/sms-brandname-success', '_parent');
                            }

                            else {
                                $formSuccess.removeClass('hidden').addClass('error_message').removeClass('success_message').html(res.message);
                            }
                        }

                        else if (res.success == false) {
                            $formSuccess.removeClass('hidden').addClass('error_message').removeClass('success_message').html('Có lỗi xảy ra, thử lại sau.');
                        }
                    }
                });
            }
        },
    });

    jQuery('img[data-original]').lazyload({
        effect: 'fadeIn'
    });

    jQuery('.banner-slider').slick({
        autoplay: true,
        autoplaySpeed: 8000
    });

    $("#show-map").on('click', function () {
        $(this).hide();
        var map = $("#map");
        map.attr('src', map.attr('data-src')).attr('height', 450);
    });

    $("#subscribeform").GNDFormValidate({
        'errorOutputMode': 'single',
        'messageLocale': 'vi',
        'messageSingleTemplate': '{message}',
        successCallBack: function (e) {
            e.preventDefault();
            var form = $("#subscribeform");
            $.ajax({
                url: ajaxSetup.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    'action': 'add_subscribe',
                    'email': form.find('input[name="subemail"]').val()
                },
                'beforeSend': function () {

                },
                'complete': function () {

                },
                'success': function (res) {
                    if (res.success) {
                        form.find('input[name="subemail"]').val('');
                        form.find('.success-message').html('Bạn đã đăng ký nhận tin thành công');
                        form.find('div[data-error-message-for="subemail"]').html('');
                    }
                    else {
                        form.find('.success-message').html('');
                        form.find('div[data-error-message-for="subemail"]').html('Có lỗi xảy ra, thử lại sau.');
                    }

                    if (res.exist) {
                        form.find('.success-message').html('');
                        form.find('div[data-error-message-for="subemail"]').html('Email đã đăng ký nhận tin');
                    }
                }

            });
        }
    });

    $('#clientList').slick({

        slidesToShow: 4,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 3500,
        dots: true,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev slider__prev"><i class="fa fa-arrow-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next slider__next"><i class="fa fa-arrow-right"></i></button>',
        dotsClass: 'slider__dot slick-dots',

        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    autoplaySpeed: 2000,
                    slidesToScroll: 1

                }
            }
        ]
    });


    $(".menuItem").on('click', function () {

        if ($(window).width() < 992) {

            $("#navigation").hide();
            $("#nav").hide();
        }


    });

    $(".navbar-toggle").on('click', function () {
        if ($(window).width() < 992) {

            $("#navigation").show();
            $("#nav").show();
        }
    });


});

